export const loadPDFMakeLib = async (data) => {
  return new Promise((resolve) => {
    const url =
      "https://cdn.jsdelivr.net/npm/pdfmake@0.1.68/build/pdfmake.min.js";
    const pdfMakeLibScript = document.getElementById("pdfmakeLib_ze21");
      if (pdfMakeLibScript !== null) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = url;
    script.id = "pdfmakeLib_ze21";
    script.onload = () => {
      resolve(true);
      console.log("Info:PDF Make library loaded.");
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};
export const loadFontLib = async (data) => {
  return new Promise((resolve) => {
    const url = "./vfs_fonts.js";
    const fontScript = document.getElementById("pdfmakeFontLib_ze22");
    if (fontScript !== null) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = url;
    script.id = "pdfmakeFontLib_ze22";
    script.onload = () => {
      console.log("Info:PDF font loaded.");
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};
